import React from 'react';
import axios from 'axios';
import legolasApi from '../../api/legolas';
import { useNavigate,useParams } from 'react-router-dom';
import globalStyles from '../../utils/globalStyles';
import { Box, Typography,TableContainer, Table, TableBody, TableCell,TableRow,
  Paper,Switch,InputLabel,Link,Snackbar,Alert,BottomNavigation,BottomNavigationAction,RadioGroup, Radio, FormControlLabel,Rating,CircularProgress} from '@mui/material';
import { useRedirect } from "react-admin";
import { useForm, Controller } from "react-hook-form";

function DetailedReview() {
  const media_cdn =process.env.REACT_APP_MEDIA_CDN_PATH;
  let { id } = useParams();
  const [reviewData,setReviewData] = React.useState({});
  const [isShortDescription, setShortDescription] = React.useState(true);
  const [openAlert, setOpenAlert] = React.useState(false)
  const {  control } = useForm({})
  const [adminApproved, setAdminApproved] = React.useState(true);
  const localStorageUser = localStorage.getItem('user');
	const user = JSON.parse(localStorageUser);
  const userid = user.id
	const adminRoleId = user.admin_role_id;
  let isChecked
  const userIds = [143];
  const redirect = useRedirect();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = React.useState(false);

  const tableCellLeft = {
    fontSize:'18px',
    fontWeight: 500,
    align:'left'
  }

  const tableCellRight = {
    fontSize:'18px',
    fontWeight: 400,
    align:'left',
    width: '70%'
  }
 const  getdetails = () =>{
    const reviewid = id
    axios.get(`${legolasApi.url}/product/review/detailedReview/${reviewid}`).then((res) => {
        if(res.data && res.status){
          if (res.data.data.adminApproved !== undefined) {
            setAdminApproved(res.data.data.adminApproved);
          }
            setReviewData(res.data.data)
        }
        // console.log("databy id",res.data)
       
    }).catch((error) => {
        console.error("Error fetching review data:", error);
      });
 }

 React.useEffect(() => {
   getdetails();
  }, []);

  const handleSwitchChange = (event) => {
    const newValue = event.target.value;
    setAdminApproved(newValue);
    setIsLoading(true);
    handleUpdate(newValue);

  };
  const handleUpdate = (isChecked) => {
    const reviewid = id;
    let valuesData = {
      adminApproved: isChecked,
    };
    axios.post(`${legolasApi.url}/product/review/adminapproved/${reviewid}`, valuesData).then((res) => {
      console.log("resss",res);
      if (res.data && res.status) {
        handleAlertGen();
      }
    }).catch((error) => {
      console.error("Error updating review data:", error);
    }).finally(() => {
      setIsLoading(false);
    });
  };
  const toggleDescriptionTruncation = () => {
    setShortDescription(!isShortDescription);
  };
  const handleAlertGen = () => {
     setOpenAlert(true);  
  }

  const closeAlert = () => {
    setOpenAlert(false);
  }
  return (
    <>
      <Box sx={{ width: '100%', height: 'auto', backgroundColor: '#fff !important', margin: '0px 20px' }}>
      <Snackbar open={openAlert} autoHideDuration={4000} onClose={closeAlert} anchorOrigin={{ vertical: 'top', horizontal: 'center' }}>
        <Alert onClose={closeAlert} severity="success" sx={{ width: '400px', marginTop: '100px' }}>
        Status has been Changed SuccessFully
        </Alert>
      </Snackbar>
      {isLoading && (
        <CircularProgress
          sx={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)' }}
          size={40}
          thickness={4}
          color="primary"
        />
      )}
      <Box sx={{
                    marginTop: '42px', marginLeft: '15px',
                    '& .MuiTypography-root': {
                        fontSize: '2.5rem',
                        fontWeight: 400,
                        color: '#000'
                    }
                }}>
                    <Typography variant='h3'>Review Details </Typography>
                    <BottomNavigation
                        showLabels
                        sx={globalStyles.bottomNavigationMenuNew}>
                        <BottomNavigationAction onClick={() => navigate(-1)} label="Back"
                            sx={{
                                backgroundColor: '#2b3f7a !important',
                                border: '1px solid #2b3f7a !important',
                                color: '#fff !important',
                                '& .Mui-selected': {
                                    color: '#fff !important'
                                }
                            }} />
                    </BottomNavigation>
                </Box>
          <Box sx={{marginLeft:'40px'}}> 
            <RadioGroup
                  aria-labelledby="demo-radio-buttons-group-label"
                  value={adminApproved}
                  id="shipping_method"
                  sx={{ display: 'flex', flexDirection: 'row', marginLeft:'20px'}}
              >
                <FormControlLabel value="Approved" control={<Radio />} label="Approved" sx={{marginRight:'60px'}}  onChange={adminRoleId === 1 || userIds.includes(userid) ? handleSwitchChange : null} />
                <FormControlLabel value="Disapproved" control={<Radio />} label="Disapproved"   onChange={adminRoleId === 1 || userIds.includes(userid) ? handleSwitchChange : null}/>
                <FormControlLabel value="Pending" control={<Radio />} label="Pending"   onChange={adminRoleId === 1 || userIds.includes(userid) ? handleSwitchChange : null}/>

            </RadioGroup>
            </Box>
            <TableContainer component={Paper} sx={{ margin: '20px 30px', width: '94%' }}>
                <Table>
                    <TableBody>
                        <TableRow>
                            <TableCell style={tableCellLeft}>Name</TableCell>
                            <TableCell style={tableCellRight}>{reviewData.userName}</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell style={tableCellLeft}>Email</TableCell>
                            <TableCell style={tableCellRight}>{reviewData.reviewEmailId}</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell style={tableCellLeft}>Product Name</TableCell>
                            <TableCell style={tableCellRight}>{reviewData.item_name ? reviewData.item_name :''}</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell style={tableCellLeft}>Rating</TableCell>
                            <TableCell style={{ textAlign: 'left' }}>
                            {reviewData.rating && (
                            <div><Rating name="read-only" value={reviewData.rating} precision={0.5} readOnly /></div>
                            ) }
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell style={tableCellLeft}>Review Title</TableCell>
                            <TableCell style={tableCellRight}>{reviewData.reviewTitle}</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell style={tableCellLeft}>Review Description</TableCell>
                                {reviewData.reviewDescription && (
                                <TableCell style={tableCellRight}>
                                {isShortDescription
                                    ? reviewData.reviewDescription.length > 80
                                    ? `${reviewData.reviewDescription.slice(0, 80)}...`
                                    : reviewData.reviewDescription
                                    : reviewData.reviewDescription}
                                    {reviewData.reviewDescription.length > 80 && (
                                    <Link style={{border:'1 px solid #3e5aaf' ,backgroundColor:globalStyles.colors.backgroundPrimary ,borderRadius:'5px' ,cursor: 'pointer', }} onClick={toggleDescriptionTruncation}>
                                    {isShortDescription ? ' Show More' : 'Show Less'}
                                    </Link>
                                )}
                                </TableCell>
                                  )}
                            </TableRow>
                        <TableRow>
                            <TableCell style={tableCellLeft}>Images</TableCell>
                            <TableCell style={{ textAlign: 'left' }}>
                            {reviewData && reviewData.image_desc && Array.isArray(reviewData.image_desc) ? (
                                    <div style={{ display: 'flex', flexWrap: 'wrap' }}>
                                        {reviewData.image_desc.map((item, index) => (
                                      
                                            <div key={index} style={{ width: '200px', height: '200px', margin: '0 20px 20px 0' }}>
                                              <a href={media_cdn + "/" + item.thumbUrl} target="_blank">
                                                 <img style={ {width: '200px', height: '200px', margin: '0 20px 20px 0'}}
                                                    src={media_cdn + "/" + (item.thumbUrl)}
                                                    alt="image not found"
                                                />
                                                </a>
                                            </div>
                                        ))}
                                    </div>
                                ) : null}

                            </TableCell>
                          

                        </TableRow>
                    </TableBody>
                </Table>
            </TableContainer>

        </Box>


    </>
  );
}
export default DetailedReview;